import { axios } from "../axios"

export const apiGlobal = {
    getGlobalData: (lang) => axios.get(`/global?populate=*?lang=${lang}`)
}